import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: ``
})
export class SpinnerComponent {
  @HostBinding('class.app-spinner')
  isAppSpinner = true;
}
